// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1k1tx","footer":"Form_footer__17uAv"};